// Extension → MIME type(s) mapping. Single source of truth for allowed data upload file types.
const ALLOWED_FILE_TYPES: Record<string, string[]> = {
  '.png': ['image/png'],
  '.jpg': ['image/jpg'],
  '.jpeg': ['image/jpeg'],
  '.pdf': ['application/pdf'],
  '.docx': ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  '.txt': ['text/plain'],
  '.csv': ['text/csv'],
  '.xls': ['application/vnd.ms-excel'],
  '.xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  '.xlsm': ['application/vnd.ms-excel.sheet.macroEnabled.12'],
  '.mp3': ['audio/mpeg'],
  '.mp4': ['video/mp4'],
  '.wav': ['audio/wav'],
  '.aac': ['audio/aac'],
  '.flac': ['audio/flac'],
  '.ogg': ['audio/ogg'],
  '.m4a': ['audio/mp4', 'audio/x-m4a'],
  '.mov': ['video/quicktime'],
  '.eml': ['message/rfc822'],
};

export const ALLOWED_EXTENSIONS = Object.keys(ALLOWED_FILE_TYPES);

export const FILE_BUTTON_ACCEPT = ALLOWED_EXTENSIONS.join(',');

// Inverted mapping: MIME type → extensions, for Mantine Dropzone's accept prop
export const DROPZONE_ACCEPT = Object.entries(ALLOWED_FILE_TYPES).reduce<Record<string, string[]>>(
  (acc, [ext, mimeTypes]) => {
    for (const mime of mimeTypes) {
      if (!acc[mime]) acc[mime] = [];
      acc[mime].push(ext);
    }
    return acc;
  },
  {},
);

export const SUPPORTED_FORMATS_LABEL = Object.keys(ALLOWED_FILE_TYPES)
  .map(ext => ext.slice(1).toUpperCase())
  .join(', ');

export const isAudioFile = (fileType: string, fileName: string): boolean =>
  fileType?.startsWith('audio/') || /\.(mp3|wav|aac|flac|ogg|m4a)$/i.test(fileName || '');
